{
  "REQUEST_DETAIL_HISTORY_LEAD_EXTERNAL_USER_AGAIN": "Changes communicated externally to:",
  "LEAD_ERRORMSG_ASSIGN_EXTERNAL_EMAIL": "You can only assign a task to one person by e-mail. The e-mail will not be sent correctly if multiple recipients are entered.",
  "FORM_COMPLETE_MANDATORY_FIELDS": "Please fill in all *mandatory fields.",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_SEARCH_PLACEHOLDER": "Dealer partner",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_EMAIL": "Enter e-mail address",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_EMAIL_PLACEHOLDER": "E-mail address",
  "ACTION_LEAD_FORWARD_OTHER_MANDANT_TEXT": "Suitable for your region and competence. For details please take over processing.",
  "GENERAL_TEXT_OFFER_NUMBER_AMOUNT": "Offer no./sum (net)",
  "GENERAL_TEXT_ORDER_NUMBER_AMOUNT": "Order no./sum (net)",
  "REQUEST_DETAIL_LEAD_HISTORY_REMINDER_EXT": "Changes communicated externally to:",
  "MESSAGE_SUBSEQUENT_CHANGE_CONTACT": "Enquiry processed on",
  "FORM_ERRORMSG_HEADLINE_MANDATORY_FIELDS": "*Mandatory fields",
  "FORM_HEADLINE_E-MAIL": "E-mail",
  "FORM_HEADLINE_LANGUAGE": "Language",
  "FORM_HEADLINE_MOBILE": "Mobile",
  "REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA": "Yes, the prospective customer agrees to the contact and enquiry data being stored and forwarded to Finstral partners if required.",
  "REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_DOCUMENTED_BY": "Documented by",
  "REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE": "Are you sure that you want to delete the note?",
  "REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE_CONFIRM": "Confirm",
  "REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE_CANCEL": "Cancel",
  "REQUEST_DETAIL_CONTACT_LINK_DELETE": "Are you sure that you want to remove the linked contact?",
  "REQUEST_CREATE_CONTACT_HEADLINE_CITY": "Locality",
  "REQUEST_CREATE_CONTACT_HEADLINE_COUNTRY": "Country",
  "REQUEST_CREATE_CONTACT_HEADLINE_NEW_REQUEST": "New enquiry",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_EMAIL_REQUEST": "E-mail enquiry is copied to the note on the enquiry.",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_SIGNATURE": "Electronic signature",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_TELEPHONE_REQUEST": "Telephone enquiry from",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_UPLOAD_FILE": "Upload a photo of the consent",
  "REQUEST_CREATE_CONTACT_HEADLINE_PROVINCE": "Province",
  "REQUEST_CREATE_CONTACT_HEADLINE_TELEPHONE": "Phone number",
  "REQUEST_CREATE_CONTACT_HEADLINE_WORK": "Landline",
  "REQUEST_CREATE_CONTACT_HEADLINE_ZIPCODE": "Post code",
  "REQUEST_CREATE_CONTACT_HEADLINE_ADDRESS_EXTRA": "Address addition",
  "REQUEST_CREATE_CONTACT_PRIVACY_SIGNATURE": "Sign",
  "REQUEST_CREATE_CONTACT_PRIVACY_UPLOAD_FILE": "Upload photo",
  "REQUEST_CREATE_CONTACT_TYPE_TAB_COMMERCIAL": "Trade",
  "REQUEST_CREATE_CONTACT_TYPE_TAB_PLANER": "Designer",
  "REQUEST_CREATE_CONTACT_TYPE_TAB_PRIVATE": "Private",
  "REQUEST_DETAIL_EDIT_BUILDING_ADDRESS": "Change address of building project",
  "REQUEST_DETAIL_HEADLINE_ADDRESS": "Address",
  "REQUEST_DETAIL_HEADLINE_ASSIGNED": "Assigned by",
  "REQUEST_DETAIL_HEADLINE_CONSENT_PRIVACY": "Consent to processing of data",
  "REQUEST_DETAIL_HEADLINE_CONTACT": "Contact",
  "REQUEST_DETAIL_HEADLINE_CREATE": "Created by/on",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY": "Files at a glance (overview of all enquiries)",
  "REQUEST_DETAIL_HEADLINE_MODIFIED": "Last modified by/on",
  "REQUEST_DETAIL_HEADLINE_PREFERENCE": "Preference",
  "REQUEST_DETAIL_HEADLINE_STATUS": "Status",
  "REQUEST_DETAIL_HEADLINE_STORED_FILES": "Deposited files",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_PRIVACY": "Data protection:",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_PRIVACY_DOCUMENTS": "Documents/date of consent:",
  "REQUEST_DETAIL_HISTORY_LEAD_STATUS_LEAD_CREATE": "Enquiry open",
  "REQUEST_DETAIL_HISTORY_LEAD_STATUS_LEAD_TYPE": "NO STATUS CHANGE",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT": "Contact",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE": "Deadline",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_NEXT_STEP": "Next step",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_RESPONSIBLE": "Responsible",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS": "Status",
  "REQUEST_OVERVIEW_FILTER_COMPLETED_REQUESTS": "Completed",
  "REQUEST_OVERVIEW_FILTER_HEADLINE_REQUEST": "Enquiries",
  "REQUEST_OVERVIEW_FILTER_MY_REQUESTS": "Yours",
  "REQUEST_OVERVIEW_FILTER_OPEN_REQUESTS": "Open",
  "SEARCH_PLACEHOLDER": "Search...",
  "USER_PROFILE_EDIT": "Edit profile",
  "USER_PROFILE_EDIT_CHANGE_IMAGE": "Change profile picture",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE": "Absent from - to",
  "USER_PROFILE_EDIT_HEADLINE_NAME": "Name*",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATIONS": "Summary",
  "USER_PROFILE_EDIT_HEADLINE_STATUS": "Status",
  "USER_PROFILE_EDIT_HEADLINE_TELEPHONE": "Phone no.",
  "USER_PROFILE_RIGHTS": "Rights",
  "USER_PROFILE_RIGHTS_HEADLINE_MY_RIGHTS": "User rights",
  "USER_PROFILE_RIGHTS_HEADLINE_TEAM": "In my team",
  "EMAIL_TEMPLATE_OFFER_1": "We have passed it on to the nearest technical advisor. He/she will contact you shortly and then prepare the offer.",
  "EMAIL_TEMPLATE_OFFER_2": "The contact details of the expert advisor are:",
  "EMAIL_TEMPLATE_OFFER_3": "Your enquiry ID is {ID}.",
  "EMAIL_TEMPLATE_OFFER_4": "We are always pleased to help if you have any questions.",
  "REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_CREATE_EXTERNAL": "Consultation meeting agreed (externally) on:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_SUBMIT_EXTERNAL": "Offer handover arranged (externally) on:",
  "ALT_TEXT_IMAGE_OPEN_TAB": "Open image in a new tab",
  "EMAIL_TEMPLATE_START_2": "Thank you for your enquiry and your interest in our products.",
  "ACTION_OFFER_HANDOVER_LINK_OFFER_COMPOSER": "Link offers in Composer with enquiry ID from Contacts – this is how it works",
  "ALT_TEXT_OFFER_ORDER_CREATED_COMPOSER": "created in Finstral Composer",
  "ALT_TEXT_OFFER_ORDER_EDIT_MANUALLY": "edit manually",
  "GENERAL_TEXT_ORDER_AMOUNT_NONE": "none yet",
  "GENERAL_TEXT_PLANER_KOMPOSITION": "Planner composition",
  "REQUEST_OVERLAY_HEADLINE_OFFER_ORDER": "Offers and orders for this enquiry",
  "REQUEST_OVERLAY_HEADLINE_OFFER_ORDER_VALUE": "Make alternative offer",
  "REQUEST_OVERLAY_HEADLINE_OFFER_ADD_MANUALLY": "Add offer manually",
  "REQUEST_OVERLAY_HEADLINE_ORDER_ADD_MANUALLY": "Add order manually",
  "REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_BECOMES_OFFER": "Make alternative offer.",
  "REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_BECOMES_OFFER_TEXT_OFFER": "is now the offer.",
  "REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_BECOMES_OFFER_TEXT_ALTERNATIVE": "is now the alternative.",
  "REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_ADDED": "Added as alternative:",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_ADDED": "Added as offer:",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_ADDED_MANUALLY": "Offer added manually:",
  "REQUEST_DETAIL_LEAD_HISTORY_ORDER_ADDED_MANUALLY": "Order added manually:",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_CONNECTION": "Links from the Finstral Composer",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_CHANGED_MANUALLY": "Offer modified manually:",
  "ACTION_OFFER_SUBMIT_HINT_NO_OFFER": "Sorry, we did not find any offers either linked to this enquiry ID or added manually. You can view and edit the offers in the extended header of the enquiry or link offers in the Composer with the enquiry ID",
  "CONTACT_ERRORMSG_EXTERNAL_DEALER": "There is a dealer partner with this e-mail address: please search for it accordingly in the dealer partner search above.",
  "CONTACT_ERRORMSG_EXTERNAL_CONTACTS_USER": "There is already a Contacts user with this e-mail address: please go back to the detail view and use the action \"Assign enquiry” instead.",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_AREA_SALES_MANAGER": "Responsible sales manager",
  "REQUEST_OVERLAY_HEADLINE_ORDER": "Orders",
  "REQUEST_OVERLAY_HEADLINE_ALTERNATIVES": "Alternatives",
  "ACTION_OFFER_HANDOVER_MESSAGE_OFFER_NOT_FOUND": "Sorry, we did not find any offers either linked to this enquiry ID or added manually. You can view and edit the offers in the extended header of the enquiry or link offers in the Composer with the enquiry ID.",
  "SEARCH_DATE_LAST_WEEK": "Last week",
  "SEARCH_DATE_LAST_MONTH": "Last month",
  "SEARCH_DATE_OLDER_THAN_SIX_MONTHS": "Older than 6 months",
  "SEARCH_DATE_LAST_YEAR": "Last year",
  "REQUEST_CREATE_HEADLINE_SELECTED_SAMPLES": "Selected samples",
  "ACTION_GENERAL_HEADLINE_APPOINTMENT_NOTE": "Note on the appointment",
  "ACTION_GENERAL_HEADLINE_APPOINTMENT_TYPE": "Type of appointment*",
  "ACTION_GENERAL_HEADLINE_DATE": "Date*",
  "ACTION_GENERAL_HEADLINE_PERIOD": "Period",
  "ACTION_GENERAL_HEADLINE_REQUEST_NOTE": "Note on the enquiry",
  "ACTION_GENERAL_NOTE_PLACEHOLDER_": "Write enquiry text",
  "ACTION_LEAD_FORWARD_HEADLINE_SELECT_USER": "Choose users",
  "ACTION_LEAD_FORWARD_SEARCH_ALL_USER": "All users",
  "ACTION_LEAD_FORWARD_SEARCH_SUGGESTION_USER": "User from proposal list",
  "ACTION_LEAD_REJECT_HEADLINE_REJECT_REASON": "Reason for rejection",
  "ACTION_LEAD_TYPE_HEADLINE_REQUEST_TYPE": "Enquiry type",
  "ACTION_NOT_INTERESTED_HEADLINE_END_BY": "Reasons for deleting the enquiry",
  "ACTION_NOT_INTERESTED_HEADLINE_END_REASON": "Reason for cancelled enquiry",
  "ACTION_NOT_INTERESTED_HEADLINE_PRICE_DEVIATION": "Price deviation",
  "ACTION_OFFER_SUBMIT_HEADLINE_APPOINTMENT": "Handover date",
  "ACTION_OFFER_SUBMIT_HEADLINE_LOCATION": "Handover location",
  "BUTTON_BACK": "Back",
  "BUTTON_LOGOFF": "Log out",
  "BUTTON_NOTE_SUBMIT": "Send",
  "BUTTON_PROFILE_SAFE": "Save profile",
  "EMAIL_CLOSE": "If you have any questions, please contact usersupport@finstral.com.",
  "EMAIL_TEXT": "the following enquiries are urgently awaiting processing:",
  "ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_CHANGES": "Do you want to communicate the changes to external users?",
  "BUTTON_LEAD_FORWARD_EXTERNAL_USER_CHANGES": "Send e-mail with changes",
  "SEARCH_DATE": "Date",
  "SEARCH_DATE_TODAY": "Today",
  "ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_CHANGES_SUBTEXT": "You made changes to the contact or enquiry after the enquiry was assigned externally. Do you want to inform the external user about your changes and send another e-mail?",
  "USER_PROFILE_RIGHTS_HEADLINE_VORNAME": "First name *",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_CREATED": "Added as offer",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_CHANGED": "Composer offer modified",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_DELETED": "Composer offer/s deleted",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_CREATED": "Added as order",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_CHANGED": "Composer order modified",
  "ADMINISTRATION_OU_DELETE": "Delete organisational unit",
  "MESSAGE_BULK_OVERLAY_HEADER": "Ready soon...",
  "MESSAGE_BULK_OVERLAY_TEXT": "{ } of { } have been processed.",
  "MESSAGE_BULK_OVERLAY_CANCEL": "Cancel",
  "EMAIL_TEMPLATE_SUBJECT": "Thank you for your enquiry to Finstral",
  "ACTION_GENERAL_HEADLINE_SHOWROOM": "Showroom*",
  "REQUEST_DETAIL_CONTACT_ADD_COMPANY_CONTACT": "Add contact",
  "REQUEST_CREATE_CONTACT_BADGE_INACTIVE": "Inactive",
  "ACTION_LEAD_FORWARD_EXTERNAL_HEADER": "Assign enquiry externally",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_DELETED": "Composer order deleted",
  "ACTION_LEAD_FORWARD_SEARCH_SUGGESTION_PARTNER_STUDIOS": "Dealer partners & Finstral Studios",
  "EMAIL_EXTERNAL_USER_TEXT_7": "Enquiry properties",
  "MESSAGE_BRIDGE_LOADING_TIME_00": "Load desired data..",
  "MESSAGE_BRIDGE_LOADING_TIME_1A": "First from the outside...",
  "MESSAGE_BRIDGE_LOADING_TIME_1B": "...now in the middle...",
  "MESSAGE_BRIDGE_LOADING_TIME_1C": "...of course inside too...",
  "MESSAGE_BRIDGE_LOADING_TIME_2B": "...now the one for well-being...",
  "MESSAGE_BRIDGE_LOADING_TIME_2C": "...and then the sustainable ones.",
  "MESSAGE_BRIDGE_LOADING_TIME_3B": "...always functional…",
  "MESSAGE_BRIDGE_LOADING_TIME_3C": "...and always aesthetic.",
  "MESSAGE_BRIDGE_LOADING_TIME_1D": "...and then all around.",
  "MESSAGE_BRIDGE_LOADING_TIME_2A": "First, only the beautiful...",
  "REQUEST_CREATE_HEADLINE_SELECTED_CATALOGUES": "Selected brochures",
  "USER_PROFILE_RIGHTS_HEADLINE_NACHNAME": "Last name *",
  "ADMINISTRATION_OU_DETAILS": "Organizational unit details",
  "BUTTON_NEW_LEAD": "Create new enquiry",
  "CALENDAR_PLACEHOLDER": "dd.mm.yyyy",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT_LINK": "linked contacts",
  "ACTION_GENERAL_HEADLINE_REQUEST_NOTE2": "Note",
  "ACTION_GENERAL_HEADLINE_TIME": "Time",
  "REQUEST_CREATE_APPOINTMENT_MOBILE_FURTHER_DETAILS": "Further dates",
  "REQUEST_CREATE_CONTACT_MOBILE_FURTHER_DETAILS": "Further contact details",
  "REQUEST_CREATE_MOBILE_FURTHER_DETAILS": "Further enquiry details",
  "REQUEST_DETAIL_SAVE_CONTACT_DATA": "Save contact details",
  "ACTION_DUPLICATE_CHECK_SAVE_ADDITIONALLY_HEADER": "Please change the e-mail address to save the new contact additionally.",
  "ACTION_LINK_LEAD_SELECT_NO_RESULT": "No contact found.",
  "ALT_TEXT_BUTTON_DUPLICATE_USE_EXISTING_CONTACT1": "Use existing",
  "ALT_TEXT_BUTTON_DUPLICATE_USE_EXISTING_CONTACT2": "Discard new contact",
  "ACTION_DUPLICATE_CHECK_HEADER1": "Existing contact(s)",
  "ACTION_DUPLICATE_CHECK_HEADER2": "New contact",
  "ACTION_DUPLICATE_CHECK_INTRO_CONTACT": "A contact already exists for this e-mail address. Please check the differences and decide whether you want to use the existing contact, use the new contact, or whether the new contact should be created additionally.",
  "ACTION_DUPLICATE_CHECK_INTRO_CONTACTS": "There is already one or more existing contact(s) for this e-mail address. Please check the differences and decide whether you want to use one of the existing contacts, use the new contact or whether the new contact should be created additionally.",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_EVENT_PARTICIPANTS": "Participant",
  "REQUEST_OVERVIEW_FILTER_PAGINATION_1": "Display",
  "REQUEST_OVERVIEW_FILTER_PAGINATION_2": "by",
  "REQUEST_OVERVIEW_FILTER_PAGINATION_3": "previous",
  "REQUEST_OVERVIEW_FILTER_PAGINATION_4": "further",
  "ALT_TEXT_OFFER_MANUALLY": "edit manually",
  "REQUEST_DETAIL_HEADER_ORDER_EMPTY": "none yet",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_ORDER": "Manage offers & orders",
  "REQUEST_DETAIL_HEADER_MENU_ORDER": "Orders",
  "REQUEST_DETAIL_HEADER_MENU_VALUE": "Value",
  "REQUEST_DETAIL_HEADER_MENU_ALTERNATIVES": "Alternatives",
  "REQUEST_DETAIL_HEADER_MENU_ADD_OFFER_MANUALLY": "Add offer manually",
  "REQUEST_DETAIL_HEADER_MENU_ADD_ORDER_MANUALLY": "Add order manually",
  "REQUEST_DETAIL_HEADER_MENU_SUPPORT_LINK_2": "Create a new enquiry for this contact from an alternative – <a href=\"https://support.finstral.cloud/de/handbuch-finstral-contacts/aktionen-fuer-die-bearbeitung-von-anfragen/bearbeitung-anfragen\" target=\"_blank\"> how does it work?</a>?",
  "REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_SWITCH": "Set as main offer",
  "REQUEST_DETAIL_HEADER_MENU_ALTERNATIVES_EDIT": "Edit alternative manually",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EDIT": "Edit offer manually",
  "REQUEST_DETAIL_HEADER_MENU_ORDER_EDIT": "Edit order manually",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_ALTERNATIVE_CREATED": "Added as alternative",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_CHANGED": "Offer modified manually",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_DELETED": "Offer deleted manually",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_ADDED": "Offer added manually",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_CHANGED": "Order modified manually",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_DELETED": "Order deleted manually",
  "REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_ADDED": "Order added manually",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH": "Replace offer with alternative.",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_LINKS": "Links from the Finstral Composer",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH_OFFER": "is now the offer.",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH_ALTERNATIVE": "is now the alternative.",
  "REQUEST_CREATE_MOBILE_FURTHER_DIRECT_APPOINTMENT": "Arrange directly consultation meeting",
  "REQUEST_CREATE_MOBILE_FURTHER_APPOINTMENT_DETAILS": "Further dates",
  "REQUEST_DETAIL_NOTE_PHONE": "Add phone no.",
  "REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_STATUS": "hand over",
  "REQUEST_CREATE_CONTACT_EXTRA_PHONE": "Additional phone number",
  "ALT_TEXT_REQUEST_ACTION_LEAD_TAKEOVER": "Take over enquiry",
  "LEAD_ERRORMSG_APPOINTMENT_CREATE_MOBILE": "The enquiry was successfully created, but unfortunately the associated consultation meeting could not be created. Please rearrange the appointment in the detail view of the enquiry. Your Finstral Contacts Team",
  "LEAD_ERRORMSG_CREATE": "Unfortunately the enquiry could not be generated. Please try again. Your Finstral Contacts Team",
  "UPDATE_BANNER_HEADLINE": "Update of 07 August 2025",
  "ACTION_NOT_INTERESTED_PLACEHOLDER": "Please make a selection",
  "REQUEST_DETAIL_HEADER_MENU_SUPPORT_LINK_1": "Link offers in Composer with enquiry ID from Contacts – <a href=\"https://support.finstral.cloud/de/handbuch-finstral-contacts/aktionen-fuer-die-bearbeitung-von-anfragen/bearbeitung-anfragen\" target=\"_blank\"> this is how it works -</a>",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_H1": "Regular absence",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_DELEGATE": "If absent assign enquiries to",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_DELEGATE_PLACEHOLDER": "Choose users",
  "EMAIL_TEMPLATE_END_1": "Always with best regards,",
  "EMAIL_TEMPLATE_END_2": "Your Finstral Team",
  "MESSAGE_SUBSEQUENT_CHANGE_CONTACT_2": "by",
  "REQUEST_DETAIL_HISTORY_TAB_ALL_ENTRIES": "All entries",
  "REQUEST_DETAIL_HISTORY_TAB_INQUIRY_TEXT": "Enquiry text",
  "REQUEST_DETAIL_HISTORY_TAB_OFFER_ORDER": "Offers and orders",
  "REQUEST_DETAIL_HISTORY_TAB_NOTES": "Notes",
  "REQUEST_DETAIL_HISTORY_TAB_PRIVACY": "Privacy",
  "REQUEST_CREATE_CONTACT_NAME_SALUTATION": "Title",
  "REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE": "No",
  "SEARCH_CATEGORY": "Category",
  "SEARCH_CATEGORY_DOCUMENT": "Documents",
  "SEARCH_CATEGORY_CONTACT_DATA": "Contact details",
  "SEARCH_CATEGORY_RESPONSIBLE": "Person responsible",
  "REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_AGREE": "The prospective customer agrees to the use of personal data for advertising purposes.",
  "REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_DISAGREE": "The prospective customer does not agree to the use of personal data for advertising purposes.",
  "REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_AGREE": "The prospective customer agrees to the use of personal data by authorised partners of Finstral for advertising purposes.",
  "REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_DISAGREE": "The prospective customer does not agree to the use of personal data by authorised partners of Finstral for advertising purposes.",
  "REQUEST_CREATE_CONTACT_TAX_NUMBER": "Tax number of contact",
  "REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING": "Consent to data processing for advertising purposes",
  "REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING_THIRD_PARTIES": "Consent to data processing by authorised partners for advertising purposes",
  "REQUEST_DETAIL_HISTORY_CONSENT_ACCREDITATION": "Provided tax number",
  "REQUEST_DETAIL_HISTORY_PRODUCT_NUMBER": "Product number:",
  "REQUEST_DETAIL_HISTORY_INVOICE_NUMBER": "Invoice number:",
  "BUTTON_DUPLICATE_USE_EXISTING_CONTACT2": "Discard new contact",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_TAKEOVER": "Enquiry taken over by:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_START": "Enquiry matched to:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_START_SECOND_WAVE": "Enquiry additionally matched to:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_SUCCESS": "Enquiry successfully matched",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_PARTIAL": "Enquiry partially matched",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_FAILED": "Enquiry matching failed",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_ABORTED": "Enquiry matching manually cancelled",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_ASSIGNMENT_FAILED": "Enquiry assignment failed",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING": "Regularly absent time",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_FRIDAY": "Friday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_H2": "Regularly absent weekdays",
  "ACTION_NOT_INTERESTED_HEADLINE_CONTACT": "Reason for interest",
  "ACTION_NOT_INTERESTED_HEADLINE_FINSTRAL": "Reason for us",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_MONDAY": "Monday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_SATURDAY": "Saturday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_THURSDAY": "Thursday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_TUESDAY": "Tuesday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_WEDNESDAY": "Wednesday",
  "FORM_ERRORMSG_OFFER_ORDER_SUM": "Please use number format 1,234.56.",
  "REQUEST_DETAIL_HISTORY_LEAD_EXTERNAL_USER": "Enquiry externally assigned to:",
  "ALT_TEXT_BUTTON_DUPLICATE_USE_NEW_CONTACT2": "Replace existing contact",
  "ALT_TEXT_BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT2": "Maintain existing and new contact",
  "ALT_TEXT_BUTTON_BACK_TO_DUPLICATE_CHECK": "Back to \"Check duplicate”",
  "BUTTON_DUPLICATE_USE_EXISTING_CONTACT1": "Use existing",
  "BUTTON_DUPLICATE_USE_NEW_CONTACT1": "Use new",
  "BUTTON_DUPLICATE_USE_NEW_CONTACT2": "Replace existing contact",
  "BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT1": "Save new contact additionally",
  "REQUEST_OVERVIEW_FILTER_CANCEL": "Clear all filters",
  "FORM_HEADLINE_ADDITIONAL_E-MAIL": "Add e-mail address",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_ORDER_PLACED_EXTERNAL": "Order placed (externally)",
  "REQUEST_DETAIL_COMPENDIUM_HEADLINE": "Compendium",
  "REQUEST_DETAIL_COMPENDIUM_HAS_ACESS": "Access granted",
  "REQUEST_DETAIL_COMPENDIUM_NO_ACESS": "Access denied",
  "REQUEST_EDIT_CONTACT_CHECKBOX_COMPENDIUM_ACCES": "Compendium access",
  "REQUEST_EDIT_CONTACT_CHECKBOX_COMPENDIUM_ACCES_DESCRIPTION": "Enables the designer to access the Finstral Compendium",
  "UPDATE_BANNER_POINT_EIGHT": "-",
  "BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT2": "Maintain existing and new contact",
  "BUTTON_BACK_TO_DUPLICATE_CHECK": "Back to \"Check duplicate”",
  "CONTACT_ERRORMSG_EMAIL_NOT_VALID": "The e-mail address you entered is invalid.",
  "GENERAL_TEXT_CLIENT_NUMBER": "Customer number",
  "GENERAL_TEXT_OFFER_NUMBER": "Offer no.",
  "GENERAL_TEXT_BROCHURE": "Brochure",
  "GENERAL_TEXT_SAMPLE": "Sample",
  "ACTION_OFFER_SUBMIT_HEADLINE_OFFER": "Offer for this enquiry",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_CAMPAIGN": "Campaign",
  "UPDATE_BANNER_POINT_SEVEN": "-",
  "UPDATE_BANNER_POINT_SIX": "-",
  "UPDATE_BANNER_POINT_TEN": "-",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE_TIME_2": "by",
  "REQUEST_CREATE_CONTACT_NAME_TITLE": "Additional title",
  "ALT_TEXT_USER_PROFIL": "Save contact details",
  "ACTION_LEAD_REOPEN_HEADLINE_REASON": "Reason for reopening the enquiry",
  "ALT_TEXT_BUTTON_REOPEN_LEAD": "Reopen enquiry",
  "BUTTON_REOPEN_LEAD": "Reopen enquiry",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_REOPEN": "Enquiry reopened",
  "LEAD_ERRORMSG_APPOINTMENT_CREATE_MOBILE_HEADER": "Something has gone wrong.",
  "REQUEST_OVERVIEW_DETAIL_UNREAD": "Mark as unread",
  "REQUEST_DETAIL_HEADLINE_ADDRESS_PROJECT_NAME": "Name of building project",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_LEAD_TYPE": "Type",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_PROJECT": "Building project",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_COUNTRY": "Country",
  "ALT_TEXT_BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT1": "Save new contact additionally",
  "ALT_TEXT_BUTTON_DUPLICATE_USE_NEW_CONTACT1": "Use new",
  "ALT_TEXT_OFFER_COMPOSER": "created in Finstral Composer",
  "BUTTON_CHANGE": "Change",
  "BUTTON_CHANGE_LEAD_TYPE": "Change enquiry type",
  "BUTTON_DELETE_LEAD": "Delete enquiry",
  "BUTTON_LINK_LEAD": "Link contact",
  "BUTTON_LINK_LEAD_NEW_CONTACT": "New contact",
  "BUTTON_REQUEST_DETAIL": "Enquiry details",
  "CONTACT_ERRORMSG_HEADLINE_NO_EMAIL": "No e-mail address stored.",
  "CONTACT_ERRORMSG_HEADLINE_UPDATE_CONTACT": "The contact has already been stored. You are overwriting an existing contact.",
  "CONTACT_ERRORMSG_NOTE_TEXT_TOO_LONG": "The text you wish to insert is too long.",
  "EMAIL_DAILY_GENERAL_SALUTATION": "Hello",
  "EMAIL_DAILY_NOTIFICATIONS_CLOSE": "If you have any questions, please contact contacts-support@finstral.com.",
  "EMAIL_EXTERNAL_USER_HEADLINE_FILES": "Documents",
  "EMAIL_EXTERNAL_USER_HEADLINE_HISTORY": "History",
  "EMAIL_EXTERNAL_USER_TEXT_1": "You have the following enquiry",
  "EMAIL_EXTERNAL_USER_TEXT_2": "on Finstral Contacts through",
  "EMAIL_EXTERNAL_USER_TEXT_3": "The prospective customer agrees that the contact and enquiry data may be stored and forwarded to Finstral partners if required.",
  "EMAIL_EXTERNAL_USER_TEXT_4": "Let",
  "EMAIL_EXTERNAL_USER_TEXT_5": "know promptly how the enquiry turned out.",
  "EMAIL_GENERAL_SIGNATURE_1": "Always with best regards,",
  "EMAIL_PASSWORD_RECOVER_BUTTON": "Change Cloud password",
  "EMAIL_PASSWORD_RECOVER_TEXT_2": "Please click on the link below to set a new password.",
  "EMAIL_SIGNATURE_1": "Always with best regards,",
  "EMAIL_SIGNATURE_2": "Your Finstral Team",
  "EMAIL_TEMPLATE_CAD_2": "You can find more information on planning and our architect service here: https://www.finstral.com/de/architekten-service/architekten/12-0.html",
  "EMAIL_TEMPLATE_END_BROCHURE_SAMPLE": "We wish you every success in finding your windows for life.",
  "EMAIL_TEMPLATE_GENERAL_1": "We will be pleased to send you our brochure free of charge.",
  "EMAIL_TEMPLATE_GENERAL_2": "Always in your vicinity.",
  "EMAIL_TEMPLATE_GENERAL_3": "Use our dealer locator to find Finstral dealer partners in your region who can advise you, make offers and install our products: https://www.finstral.com/händlersuche",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_1": "So as always to be close to our customers, we work with partners who can advise them, make offers and install our products.",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_2": "In order to process your enquiry in the best possible way or to forward it to a dealer partner in your area, it would be very helpful if you could tell us where the building project is located – the postcode and town would be sufficient.",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_3": "Can you also be reached by phone?",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_4": "Then please also send us your contact details.",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_5": "Many thanks!",
  "EMAIL_TEMPLATE_PRODUCT_ADVICE_6": "We look forward to your reply and thank you in advance.",
  "EMAIL_TEMPLATE_START_1": "Dear Mr/Mrs/Ms {Lead family name}",
  "EMAIL_TEMPLATE_TENDER_1": "In order to be able to process your enquiry in detail, we would be grateful if you could provide us with further contact details (address of the location, town and state).",
  "ERROR_ACTION_DELETE": "You are not authorised to delete the enquiry.",
  "ERROR_LINK_LEAD_NEW_CONTACT": "The contact cannot be created. A contact with this e-mail address already exists.",
  "GENERAL_ERROR_FIELD_TO_LONG": "Please check the marked fields.",
  "GENERAL_ERROR_HEADLINE": "An error has occurred.",
  "GENERAL_ERROR_TEXT": "We are sorry but an error has occurred. The best thing to do is to contact Finstral Contacts Support.",
  "GENERAL_TEXT_CLIENT_NUMBER_COMPOSER": "Customer no. (Composer)",
  "GENERAL_TEXT_CLIENT_NUMBER_OWN": "Customer no. (own)",
  "GENERAL_TEXT_CONSTRUCTION_TYPE": "Building project type",
  "GENERAL_TEXT_OFFER_AMOUNT": "Offer amount",
  "GENERAL_TEXT_ORDER_AMOUNT": "Order total",
  "GENERAL_TEXT_ORDER_NUMBER": "Order no.",
  "REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1": "Yes",
  "REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_2": "The prospective customer agrees that the contact and enquiry data may be stored and forwarded to Finstral partners if required.",
  "REQUEST_CREATE_CONTACT_EXTRA_EMAIL": "Additional e-mail",
  "REQUEST_CREATE_CONTACT_HEADLINE_FIRM": "Company",
  "REQUEST_CREATE_CONTACT_HEADLINE_NAME": "First Name",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_LETTER": "Letter is copied into the note of the enquiry.",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_WEB_FORM": "Privacy consent directly in the contact forms",
  "REQUEST_CREATE_CONTACT_HEADLINE_VAT": "VAT no.",
  "REQUEST_CREATE_CONTACT_JOB_TITLE": "Position",
  "REQUEST_DETAIL_ADDITONAL_ADDRESS": "Project address",
  "REQUEST_DETAIL_EXTERNAL_USER": "External user",
  "REQUEST_DETAIL_FILES_TABLE_ACTION_COPY": "Copy link",
  "REQUEST_DETAIL_FILES_TABLE_ACTION_DOWNLOAD": "Download",
  "REQUEST_DETAIL_HEADLINE_ABSENCE": "Absent",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_USER": "External user",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_DATE": "Shared on",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_FROM": "Sent by",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_NAME": "Name",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_2": "(overview of all enquiries)",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_TYPE": "Type",
  "REQUEST_DETAIL_HEADLINE_HISTORY_MOBILE": "Enquiry process",
  "REQUEST_DETAIL_HISTORY_CONSENT_PRIVACY": "Consent to processing of data",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_LEAD_TYPE": "Origin:",
  "REQUEST_DETAIL_HISTORY_TIME": "Time",
  "REQUEST_DETAIL_HISTORY_TIME_FROM": "Time from",
  "REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1": "o'clock",
  "REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2": "by",
  "REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_MOVE": "Consultation meeting postponed to:",
  "REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_REMINDER": "Enquiry placed on hold until:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_FORWARD_UNDO": "Enquiry assignment revoked to:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_NOT_INTERESTED": "Enquiry terminated by:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_REJECT": "Enquiry returned to:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_STATUS_FORWARD_UNDO": "previous step",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_GRANTED": "Compendium access granted",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_MAGIC_LINK_SENT": "Magic Link for Compendium sent",
  "REQUEST_DETAIL_LEAD_HISTORY_NEGOTIATION_CREATE": "Negotiation date arranged on",
  "REQUEST_DETAIL_LEAD_HISTORY_NEGOTIATION_MOVE": "Negotiation date postponed to:",
  "REQUEST_DETAIL_LEAD_HISTORY_NOTE": "Note:",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_DELAY": "Offer handover postponed to:",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_SUBMIT": "Offer placed on hold until:",
  "REQUEST_DETAIL_LEAD_HISTORY_ORDER_PLACED": "Order placed on:",
  "REQUEST_DETAIL_LEAD_HISTORY_REJECT_NOTE": "Reason:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_APPOINTMENT_CREATE": "Consultation meeting agreed on:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_APPOINTMENT_MOVE": "Consultation meeting agreed",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_APPOINTMENT_REMINDER": "Enquiry put on hold",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_FORWARD": "Enquiry assigned to:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_NOT_INTERESTED": "Enquiry ended",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_PROCESS": "Enquiry completed",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_REJECT": "Enquiry returned to:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_NEGOTIATION_CREATE": "Negotiation date arranged on:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_NEGOTIATION_MOVE": "Negotiation date arranged",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_DELAY": "Enquiry put on hold",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_MOVE": "Offer handover arranged:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_SUBMIT": "Offer handover arranged on:",
  "REQUEST_DETAIL_LEAD_HISTORY_STATUS_ORDER_PLACED": "Order placed",
  "REQUEST_DETAIL_LINK": "Linked (enquiries)",
  "REQUEST_DETAIL_NOTE_EMAIL": "Add e-mail",
  "REQUEST_DETAIL_NOTE_PLACEHOLDER": "Write note",
  "REQUEST_DETAIL_NOTE_UPLOAD": "Upload file (max. 20 MB)",
  "ALT_TEXT_REQUEST_DETAIL_NOTE_INFO": "Notes are visible to everyone with access to this enquiry.",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_TYPE": "Enquiry type/ID",
  "REQUEST_OVERVIEW_DETAIL": "Enquiry details",
  "REQUEST_OVERVIEW_DONE_LEAD_STATUS": "Completed on",
  "REQUEST_OVERVIEW_FILTER_ALL_REQUESTS": "All",
  "REQUEST_OVERVIEW_FILTER_ALL_REQUESTS_MOBILE": "All",
  "REQUEST_OVERVIEW_FILTER_MY_REQUESTS_MOBILE": "Yours",
  "REQUEST_OVERVIEW_FILTER_OPEN_REQUESTS_MOBILE": "Open",
  "SEARCH_CATEGORY_LEAD_ID": "Enquiry ID",
  "SEARCH_CATEGORY_KEYWORDS": "Tags",
  "SEARCH_MESSAGE_NO_RESULT_HEADLINE": "No enquiries found.",
  "USER_PROFILE_EDIT_ABSENT": "Absent",
  "USER_PROFILE_EDIT_APPOINTMENT_AVAILABLE": "Received",
  "USER_PROFILE_EDIT_GENERAL_NOT_AVAILABLE": "Not received",
  "USER_PROFILE_EDIT_HEADLINE_APPOINTMENT_NOTIFICATION": "Appointments via e-mail",
  "USER_PROFILE_EDIT_HEADLINE_GENERAL_NOT_AVAILABLE": "Not received",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATIONS_NOT_AVAILABLE": "Not received",
  "USER_PROFILE_EDIT_HEADLINE_PUSH": "Notification of receipt",
  "USER_PROFILE_EDIT_PASSWORD_NEW": "New Cloud password",
  "USER_PROFILE_EDIT_PASSWORD_NEW_KEEP": "Remember registration",
  "USER_PROFILE_EDIT_PUSH_AVAILABLE": "Received with new enquiries",
  "USER_PROFILE_RIGHTS_HEADLINE_EMAIL": "E-mail",
  "USER_PROFILE_RIGHTS_HEADLINE_LASTLOG": "Last login",
  "USER_PROFILE_RIGHTS_HEADLINE_MY_ROLL": "Roll",
  "USER_PROFILE_RIGHTS_HEADLINE_POSITION": "Position",
  "EMAIL_TEMPLATE_CLIENT_SERVICE_1": ".",
  "ALT_TEXT_USER_PROFILE_EDIT": "Edit profile",
  "EMAIL_TEMPLATE_SAMPLE_1": "We will send you the required material as soon as possible.",
  "EXPORT_CSV_HEADER_DEADLINE": "Deadline",
  "MAIL_HEADER_TYPE": "ENQUIRY TYPE/ID",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_REQUESTED": "Compendium access requested",
  "ACTION_NOT_INTERESTED_CONTACT_REASON_1": "Price ideas do not match",
  "ACTION_NOT_INTERESTED_CONTACT_REASON_2": "Delivery time too long",
  "ACTION_NOT_INTERESTED_CONTACT_REASON_3": "Product solution not suitable",
  "ACTION_NOT_INTERESTED_CONTACT_REASON_4": "Building project/refurbishment postponed",
  "ACTION_NOT_INTERESTED_CONTACT_REASON_5": "Dealer partner/Studio too far away",
  "ACTION_NOT_INTERESTED_FINSTRAL_REASON_1": "Requested product solution not feasible",
  "ACTION_NOT_INTERESTED_FINSTRAL_REASON_2": "Insufficient creditworthiness",
  "ACTION_NOT_INTERESTED_FINSTRAL_REASON_3": "Building project location too far away",
  "ACTION_NOT_INTERESTED_FINSTRAL_REASON_4": "Duplicate of another enquiry",
  "ACTION_NOT_INTERESTED_REASON_OTHER": "Other",
  "ALT_TEXT_BUTTON_ADDITIONAL_ADDRESS_DELETE": "Delete address",
  "ALT_TEXT_BUTTON_DOWNLOAD_LIST": "Download enquiry list",
  "ALT_TEXT_CONTACT_DETAIL_AVAILABILITY_STATUS": "Status available",
  "ALT_TEXT_CONTACT_DETAIL_MOBIL": "Mobile",
  "ALT_TEXT_EXTERNER_USER": "External user",
  "ALT_TEXT_FILE_OPEN_BROWSER": "Open in browser",
  "ALT_TEXT_REQUEST_ACTION_APPOINTMENT_MOVE": "Postpone consultation meeting",
  "ALT_TEXT_REQUEST_ACTION_LEAD_FORWARD": "Forward enquiry",
  "ALT_TEXT_REQUEST_ACTION_LEAD_PROCESS": "Place order",
  "ALT_TEXT_REQUEST_ACTION_LEAD_TYPE": "Update enquiry type",
  "ALT_TEXT_REQUEST_ACTION_OFFER_MOVE": "Postpone handover meeting",
  "ALT_TEXT_REQUEST_LIST_CALENDAR": "Calendar",
  "ALT_TEXT_REQUEST_LIST_DUE": "Deadline",
  "ALT_TEXT_REQUEST_LIST_GENERAL_REQUEST": "ENQUIRY TYPE/ID",
  "ALT_TEXT_REQUEST_LIST_LINK": "Link",
  "ALT_TEXT_REQUEST_LIST_SAFE": "Save",
  "ALT_TEXT_REQUEST_OVERVIEW_FILTER": "Filter search field",
  "ALT_TEXT_REQUEST_TYPE_CLAIM": "Complaint",
  "ALT_TEXT_REQUEST_TYPE_SAMPLE": "Sample",
  "ALT_TEXT_SECOND_EMAIL": "Add e-mail address",
  "EMAIL_EXTERNAL_USER_TEXT_6": "have been assigned.",
  "EMAIL_GENERAL_SIGNATURE_2": "Your Finstral Contacts Team",
  "EMAIL_NOTIFICATIONS_TEXT": "the following enquiries are urgently awaiting processing:",
  "EMAIL_PASSWORD_RECOVER_TEXT_1": "an enquiry has been made via contacts.finstral.cloud to reset your password for the Finstral Cloud.",
  "EMAIL_PASSWORD_RECOVER_TEXT_3": "This link is only valid for the next 2 hours. Afterwards, a new enquiry must be made to reset the Cloud password. If you do not want to reset your Cloud password, ignore this e-mail and no changes will be made.",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_GENERAL": "Enquiry date",
  "REQUEST_CREATE_CONTACT_HEADLINE_PRIVACY_WEB_CHAT": "Chat enquiry from",
  "REQUEST_CREATE_CONTACT_HEADLINE_WEBSITE": "Website",
  "REQUEST_CREATE_HEADLINE_LEADSOURCE": "Enquiry origin",
  "ACTION_LEAD_FORWARD_INFO_MESSAGE_TENANT_ONLY": "The “Contact maintenance” enquiry type can only be assigned within your organisation. Would you like to assign an enquiry outside your organisation? Please assign other enquiry types instead.",
  "ACTION_LEAD_FORWARD_ERROR_MESSAGE_TENANT_ONLY": "This enquiry type can only be assigned within your organisation. Please select other enquiry types for external assignment.",
  "REQUEST_DETAIL_HISTORY_TAB_COMPENDIUM": "Compendium",
  "REQUEST_DETAIL_DONE_LEAD": "Completed",
  "REQUEST_DETAIL_FILES_TABLE_ACTION_DELETE": "Delete file",
  "REQUEST_DETAIL_HEADLINE_CONTACT_ANONYMIZE": "Contact anonymous",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_LEADID": "Enquiry ID",
  "REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_1": "Show documents",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE": "for enquiry",
  "REQUEST_DETAIL_HISTORY_LEAD_CREATE_SECOND_ROW": "New enquiry created:",
  "REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_CREATE": "Consultation meeting agreed on",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_FORWARD": "Enquiry assigned to",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_PROCESS": "Enquiry completed by:",
  "REQUEST_DETAIL_LEAD_HISTORY_LEAD_TYPE": "Enquiry type defined:",
  "REQUEST_OVERVIEW_MOBILE_FILTER": "Filter",
  "REQUEST_OVERVIEW_FILTER_AND_SORT": "Filter & Sort",
  "REQUEST_OVERVIEW_FILTER_SEARCH_IN_CATEGORY": "Search in category",
  "REQUEST_OVERVIEW_FILTER_NO_COUNTRIES_FOUND": "No countries found.",
  "REQUEST_OVERVIEW_FILTER_SORT_BY": "Sort by",
  "REQUEST_OVERVIEW_FILTER_SORT_ASCENDING": "Ascending",
  "REQUEST_OVERVIEW_FILTER_SORT_DESCENDING": "Descending",
  "REQUEST_OVERVIEW_FILTER_SHOW_ONLY": "Show only",
  "REQUEST_OVERVIEW_FILTER_CREATED_ON": "Created on",
  "REQUEST_OVERVIEW_FILTER_APPLY": "Apply filters",
  "REQUEST_OVERVIEW_FILTER_SHOW_MORE_STATUS_OPTIONS": "Show more status options",
  "REQUEST_OVERVIEW_COLUMNS_HEADLINE_LAST_ACTION": "Last action",
  "REQUEST_OVERVIEW_SEARCH_RESULT_SUMMARY": ":count Enquiries for \":search\"",
  "SEARCH_MESSAGE_NO_RESULT_TEXT": "No enquiries were found that match the current filter criteria.",
  "USER_PROFILE_EDIT_HEADLINE_PASSWORD": "Security",
  "USER_PROFILE_EDIT_NOTIFICATIONS_AVAILABLE": "Receive daily",
  "USER_PROFILE_EDIT_PASSWORD_NEW_REPEAT": "Repeat new Cloud password",
  "ALT_TEXT_REQUEST_TYPE_CUSTOMER_SERVICE": "Customer service",
  "ALT_TEXT_REQUEST_TYPE_CAD_DATA": "CAD data",
  "ALT_TEXT_REQUEST_TYPE_EVENT": "Event",
  "ADMINISTRATION_DUPLICATES_NO_DUPLICATES": "No duplicates available",
  "REQUEST_DETAIL_HISTORY_APPOINTMENT_SHOWROOM": "Showroom",
  "ACTION_START_RELATIONSHIP_MANAGEMENT_INFO_TEXT_COMPENDIUM_ACCESS": "This action will send the designer an e-mail with a unique, time-limited link for the Compendium. You can also deny this access at a later time in his/her contact details.\nYou can revoke authorisation to access the Compendium at any time in the designer’s contact details.",
  "ACTION_EDIT_LEAD_TYPE_ERROR_MESSAGE_RELATIONSHIP_MANAGEMENT": "The enquiry type cannot be changed to “Relationship management”. Please select another enquiry type.",
  "REQUEST_DETAIL_LEAD_HISTORY_EVENT": "Event Name",
  "LEAD_ERRORMSG_CREATE_RELATIONSHIP_MANAGEMENT": "There is already an enquiry with the relationship management type for this contact. You can change the request type or cancel the creation of this new enquiry. Your Finstral Contacts team",
  "REQUEST_DETAIL_HEADER_PLANNER_COMPOSITION_URL": "https://planer.finstral.com/it/composizione/",
  "HEADER_LINK_SUPPORT": "<a href=\"https://support.finstral.cloud/de\" target=\"_blank\">Support</a>",
  "HEADER_LINK_REPORTING": "<a href=\"https://app.reporting.finstral.aboutbits.dev/offers?view=COMPLETION_RATE\" target=\"_blank\">Reporting</a>",
  "REQUEST_DETAIL_LEAD_HISTORY_AGENCY": "Agency",
  "REQUEST_DETAIL_LEAD_HISTORY_ORGANISER": "Organiser",
  "ADMINISTRATION_OU_EXPLANATION_TEXT": "What is an organisational unit?",
  "ADMINISTRATION_OU_STRUCTURE_HEADLINE": "Structure of organisational units",
  "ADMINISTRATION_AREA_EXPLANATION_TEXT": "What is an area?",
  "ADMINISTRATION_DUPLICATES_EXPLANATION_TEXT": "What is a duplicate?",
  "ADMINISTRATION_DUPLICATES_NO_DUPLICATES_FOUND": "We could not found any duplicates",
  "UPDATE_BANNER_POINT_TWO": "Our partners can now share self-created requests directly with Finstral – ideal for more efficient collaboration with architects.",
  "ALT_TEXT_PLANER_RELATIONSHIP": "Relationship management",
  "ALT_TEXT_DUPLICATE_CHECK": "Check duplicate",
  "EMAIL_EXTERNAL_USER_TEXT_8": "Samples / brochures",
  "MESSAGE_BRIDGE_LOADING_TIME_3A": "In a moment you will experience the data anew...",
  "REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_SEARCH": "Dealer partner search",
  "REQUEST_DETAIL_HISTORY_UPLOAD_FILE": "File/s uploaded:",
  "REQUEST_DETAIL_LEAD_HISTORY_OFFER_DELETED_MANUALLY": "Offer deleted manually:",
  "REQUEST_OVERLAY_LINK_NEW_REQUEST": "Create a new enquiry for this contact from an alternative – how does it work?",
  "SEARCH_DATE_YESTERDAY": "Yesterday",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE_TIME_1": "and",
  "USER_PROFILE_EDIT_HEADLINE_ABSENCE_RECURRING_SUNDAY": "Sunday",
  "REQUEST_DETAIL_STATUS_DONE": "Enquiry ended",
  "REQUEST_OVERVIEW_FILTER_COMPLETED_REQUESTS_MOBILE": "Completed",
  "ALT_TEXT_FILE_DELETE": "Delete",
  "SEARCH_CATEGORY_CONSTRUCTION_ADDRESS": "Building address",
  "SEARCH_CATEGORY_NOTES": "Notes",
  "REQUEST_DETAIL_SKELETON_ENQUIRY_ALREADY_ACCEPTED": "Enquiry already declined",
  "USER_PROFILE_PRIVACY_LINK": "<a href=\"https://finstral.cloud/en/privacy-policy\" target=\"_blank\">Privacy</a>",
  "BUTTON_ACTION_LEAD_FORWARD_EXT": "Assign via e-mail",
  "BUTTON_ADDITIONAL_ADDRESS_SAVE": "Save address",
  "BUTTON_DOWNLOAD_LIST": "Download enquiry list",
  "EMAIL_SALUTATION": "Hello",
  "UPDATE_BANNER_POINT_FIVE": "Further details of the update are available at <a href=\"https://support.finstral.cloud/en/contacts/latest-new-features#tab-1\" target=\"_blank\">here</a>.",
  "UPDATE_BANNER_POINT_THREE": "Also new: improved editing of the request header, new copy functions for contact data with active feedback, Excel export extended with the \"Position\" column and further improvements!",
  "EMAIL_TEMPLATE_BROCHURE_1": "We will send you the required material as soon as possible.",
  "ALT_TEXT_KEY2HELP": "My tickets",
  "ALT_TEXT_LOGOUT": "Logout",
  "ALT_TEXT_SAVE_PROFILE": "Save",
  "ALT_TEXT_USER_EMAIL": "E-mail",
  "ALT_TEXT_USER_PHONE": "Phone",
  "ALT_TEXT_REQUEST_TYPE_TENDER": "Tender specifications",
  "REQUEST_DETAIL_ASSIGN_SEARCH_PLACEHOLDER": "Search for client reference no., name, OU",
  "REQUEST_DETAIL_FILES_TABLE_ACTION_OPEN": "Open in browser",
  "REQUEST_CREATE_CONTACT_HEADLINE_LAST_NAME": "Last name",
  "REQUEST_DETAIL_HEADER_ADD_TAG_PLACEHOLDER": "Enter tag and press enter",
  "REQUEST_CREATE_APPOINTMENT_BADGE_EXTERNAL_ENQUIRY": "External enquiry",
  "REQUEST_DETAIL_HEADLINE_POSITION": "Position",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATIONS_AVAILABLE": "Received",
  "USER_PROFILE_EDIT_PASSWORD_OPTION": "Change Cloud password",
  "USER_PROFILE_RIGHTS_HEADLINE_NAME": "Name",
  "USER_PROFILE_STATUS": "Status available",
  "ACTION_APPOINTMENT_CREATE_CURRENCY": "currency",
  "ACTION_APPOINTMENT_OVERLAP": "You already have an appointment planned during this time.",
  "ACTION_DELETE_HEADLINE_DELETE": "Definitively delete enquiry?",
  "ACTION_GENERAL_HEADLINE_PERIOD_HALF_YEAR": "In half a year",
  "ACTION_GENERAL_HEADLINE_PERIOD_MONTH": "In one month",
  "ACTION_GENERAL_HEADLINE_PERIOD_WEEK": "In one week",
  "ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER": "Assign via e-mail",
  "ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_RIGHT": "The external user has the right to see the enquiry and contact details.",
  "ACTION_LEAD_TYPE_HEADLINE_LEAD_TYPE": "Enquiry type",
  "ACTION_LINK_LEAD_HEADLINE_CONECT_LEAD": "Link enquiry",
  "ACTION_LINK_LEAD_PLACEHOLDER": "Search contact",
  "ACTION_LINK_LEAD_SELECT_CONTACT": "Please select a contact to which you would like to link the enquiry:",
  "ACTION_OFFER_SUBMIT_HEADLINE_COMPOSER": "The offer in Finstral Composer",
  "ACTION_ORDER_PLACED_HEADLINE_COMPOSER": "The order in Finstral Composer",
  "ALT_TEXT_BUTTON_ADDITIONAL_ADDRESS_SAVE": "Save address",
  "ALT_TEXT_BUTTON_DELETE_LEAD": "Delete enquiry",
  "ALT_TEXT_BUTTON_UPLOAD": "Upload",
  "ALT_TEXT_CONTACT_DETAIL_BUILDING_ADDRESS": "Building address",
  "ALT_TEXT_CONTACT_DETAIL_DIGITAL_SIGNATURE": "Electronic signature",
  "ALT_TEXT_CONTACT_DETAIL_EMAIL": "E-mail",
  "ALT_TEXT_CONTACT_DETAIL_PHONE": "Landline",
  "ALT_TEXT_FILE_COPY_LINK": "Retrieve link",
  "ALT_TEXT_FILE_DOWNLOAD": "Download",
  "ALT_TEXT_REQUEST_ACTION_APPOINTMENT_CREATE": "Arrange consultation meeting",
  "ALT_TEXT_REQUEST_ACTION_APPOINTMENT_REMINDER": "Put on hold",
  "ALT_TEXT_REQUEST_ACTION_LEAD_CREATE": "Create new enquiry",
  "ALT_TEXT_REQUEST_ACTION_LEAD_FORWARD_UNDO": "Revoke assignment",
  "ALT_TEXT_REQUEST_ACTION_LEAD_NOT_INTERESTED": "Linked enquiry",
  "ALT_TEXT_REQUEST_ACTION_LEAD_REJECT": "Reject enquiry",
  "ALT_TEXT_REQUEST_ACTION_NEGOTIATION_CREATE": "Arrange negotiation date",
  "ALT_TEXT_REQUEST_ACTION_NEGOTIATION_MOVE": "Postpone negotiation date",
  "ALT_TEXT_REQUEST_ACTION_OFFER_SUBMIT": "Arrange handover meeting",
  "ALT_TEXT_REQUEST_DETAIL_LEAD_DELETE": "Delete enquiry",
  "ALT_TEXT_REQUEST_DETAIL_LEAD_FORWARD": "Assign enquiry",
  "ALT_TEXT_REQUEST_LIST_CONTACT": "Contact",
  "ALT_TEXT_REQUEST_LIST_EDIT": "Edit",
  "ALT_TEXT_REQUEST_LIST_EDIT_REQUEST": "Edit enquiry",
  "ALT_TEXT_REQUEST_LIST_FILE": "Files",
  "ALT_TEXT_REQUEST_LIST_INFORMATION": "Information",
  "ALT_TEXT_REQUEST_LIST_NEXT_STEP": "Next step",
  "ALT_TEXT_REQUEST_LIST_RESPONSIBLE": "Responsibility",
  "ALT_TEXT_REQUEST_LIST_STATUS": "Status",
  "ALT_TEXT_REQUEST_TYPE_BROCHURE": "Brochure",
  "ALT_TEXT_REQUEST_TYPE_GENERAL": "General",
  "ALT_TEXT_REQUEST_TYPE_OFFER": "Offer",
  "ALT_TEXT_REQUEST_TYPE_TECNICAL_QUESTION": "Product advice",
  "ALT_TEXT_USER_PROFIL_CHANGE_PASSWORD": "Change Cloud password",
  "ALT_TEXT_USER_RIGHT": "Rights",
  "BUTTON_ADDITIONAL_ADDRESS_DELETE": "Delete address",
  "REQUEST_DETAIL_HISTORY_TIME_FROM_AFTER_TIME": "Time from",
  "USER_MANAGEMENT_CREATE_USER_NOTIFCATION_TEXT_2": "Many thanks for your attention.",
  "USER_MANAGEMENT_CREATE_USER_NOTIFCATION_TEXT_4": "We will contact you after checking.",
  "USER_MANAGEMENT_DEACTIVATE_USER_BUTTON_SAVE": "Save",
  "USER_MANAGEMENT_DEACTIVATE_USER_DROPDOWN_REASON": "Reason",
  "USER_MANAGEMENT_DEACTIVATE_USER_HEADLINE": "Do you want to deactivate the user :UserName?",
  "ADMINISTRATION_SAVE_CHANGES": "Save editing",
  "ADMINISTRATION_OU_BLOCK_CONTACTS_TYPES": "Responsible for contact types",
  "REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_HEADLINE": "Accept enquiry",
  "REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_TEXT": "Please accept the enquiry to see further details. If you decline, the enquiry will be returned to Finstral.",
  "REQUEST_OVERVIEW_MESSAGE_ENQUIRY_ALREADY_ACCEPTED": "You have already declined the enquiry and cannot therefore reopen it.",
  "DEADLINE_DAYS_FUTURE_PLURAL": "in {0} days",
  "DEADLINE_DAYS_FUTURE_SINGULAR": "in one day",
  "DEADLINE_HOURS_FUTURE_PLURAL": "in {0} hours",
  "DEADLINE_HOURS_FUTURE_SINGULAR": "in one hour",
  "DEADLINE_MINUTES_FUTURE_PLURAL": "in {0} minutes",
  "DEADLINE_MINUTES_FUTURE_SINGULAR": "in one minute",
  "DEADLINE_WEEKS_FUTURE_PLURAL": "in more than {0} weeks",
  "DEADLINE_WEEKS_FUTURE_SINGULAR": "in more than one week",
  "EMAIL_APPOINTMENT_SUBJECT_MOVE": "Enquiry {0}: {1} Postponed",
  "EMAIL_APPOINTMENT_TEXT_2": "All details about the date and contact can be found here.",
  "EMAIL_APPOINTMENT_TEXT_MOVE": "Your appointment for enquiry {0} on {1} has been postponed to {2}.",
  "EMAIL_APPOINTMENT_TEXT_NEW": "You have made an appointment for enquiry {0} on {1}.",
  "EMAIL_EXTERNAL_HISTORY_ACTION_APPOINTMENT_CREATE": "New appointment {0} made on {0}",
  "EMAIL_EXTERNAL_HISTORY_ACTION_APPOINTMENT_MOVE": "Appointment postponed to {0}",
  "EMAIL_EXTERNAL_HISTORY_ACTION_OFFER": "{0} for offer handover arranged on {1}",
  "EMAIL_EXTERNAL_HISTORY_ACTION_TYPE": "Enquiry type changed to {0}",
  "EMAIL_EXTERNAL_HISTORY_LABEL_COMMENT": "Comment:",
  "EMAIL_EXTERNAL_TEXT_2": "Please contact the prospective customer to arrange a consultation meeting and an offer handover.",
  "EMAIL_EXTERNAL_TEXT_DOCUMENTS": "We will be happy to send you all the necessary files on request.",
  "EMAIL_EXTERNAL_TEXT_GVL": "Please contact your responsible area sales manager if you have any questions and/or would like to give feedback on the enquiry:",
  "EMAIL_LEAD_EXTERNAL_TEXT": "Suitable for your region and competence. For details please take over handling of the request.",
  "EXPORT_CSV_HEADER_APPOINTMENT_CLASS": "Appointment location",
  "EXPORT_CSV_HEADER_COMPLETED": "Open/Completed",
  "EXPORT_CSV_HEADER_EVENTS": "Event data",
  "EXPORT_CSV_HEADER_EXTERNAL_GVL": "Area sales manager",
  "EXPORT_CSV_HEADER_EXTERNAL_KKZ": "External client reference no.",
  "EXPORT_CSV_HEADER_NR": "Enquiry number",
  "EXPORT_CSV_HEADER_TYPE": "Request type",
  "MAIL_HEADER_DEADLINE": "DEADLINE",
  "MAIL_POST_TEXT": "Should you have any queries, you can always reach us at usersupport@finstral.com.",
  "MAIL_SUBJECT": "Finstral Contacts • daily overview of enquiries for processing",
  "MAIL_SUBJECT_LEAD": "Finstral Contacts - new enquiry for processing",
  "MIGRATE_EIN_CAPTION": "Finstral CRM Import from",
  "MIGRATE_EIN_COMMENT1": "Comment",
  "MIGRATE_EIN_GEB": "Area",
  "MIGRATE_EIN_GVL": "Area sales manager",
  "MIGRATE_EIN_VL": "Sales manager",
  "REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_LINK_OVERVIEW": "To enquiry list",
  "ERROR_MESSAGE_INVALID_TEXT_INPUT_FIELD": "The inserted text is not allowed. Please check the characters and symbols entered.",
  "REQUEST_DETAIL_CONTACT_ADD_NEW_ENQUIRY": "Add enquiry",
  "EMAIL_EXTERNAL_HISTORY_ACTION_TAKEOVER": "Enquiries taken over by {0}",
  "EMAIL_EXTERNAL_LABEL_ARTICLES": "Articles/brochures",
  "EMAIL_EXTERNAL_TEXT_3": "Let {0} know promptly how the enquiry turned out.",
  "EXPORT_CSV_HEADER_COMMENTS": "Comments",
  "EXPORT_CSV_HEADER_EMAIL": "E-mail address",
  "EXPORT_CSV_HEADER_EVENT_ATTENDEES": "Event participants",
  "EXPORT_CSV_HEADER_LASTNAME": "Contact surname",
  "MAIL_GREETINGS": "Always with best regards<br />Your Finstral Contacts Team",
  "MAIL_SUBJECT_LEAD_EXTERNAL": "New Contacts enquiries to be taken over",
  "MIGRATE_EIN_COMMENT3": "Additional note",
  "USER_MANAGEMENT_DEACTIVATE_USER_MESSAGE": "When this enquiry is sent, the affected user is deactivated for all existing applications in the Cloud and will no longer be visible in this overview after processing.",
  "USER_MANAGEMENT_DEACTIVATE_USER_TEXTFIELD_NOTE": "Note",
  "USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_3": "Role",
  "USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_5": "active?",
  "EMAIL_USER_MANAGEMENT_AFFECTED_USER": "For the following user:",
  "EMAIL_USER_MANAGEMENT_DEACTIVATE_USER_CLOSING_TEXT": "Thank you for processing this deactivation.",
  "EMAIL_USER_MANAGEMENT_DEACTIVATE_USER_OPENING_TEXT": "a user deactivation was requested via the Finstral Cloud:",
  "EMAIL_USER_MANAGEMENT_DEACTIVATE_USER_REASON": "Reason:",
  "EMAIL_USER_MANAGEMENT_DEACTIVATE_USER_SUBJECT": "Request deactivation Cloud user",
  "EMAIL_USER_MANAGEMENT_EMAIL_USER": "E-mail of user:",
  "EMAIL_USER_MANAGEMENT_GREETING": "Dear Finstral employee,",
  "EMAIL_USER_MANAGEMENT_NAME_USER": "Name of user:",
  "EMAIL_USER_MANAGEMENT_NOTES": "Notes:",
  "EMAIL_USER_MANAGEMENT_REGARDS_1": "Always with best regards,",
  "EMAIL_USER_MANAGEMENT_REGARDS_2": "The Finstral Cloud",
  "EMAIL_USER_MANAGEMENT_REQUESTOR": "Enquiry sent by:",
  "REQUEST_DETAIL_CONTACT_OHTER_COMPANY_CONTACTS": "Other contacts from",
  "REQUEST_CREATE_CONTACT_COMPANY_HELPER_TEXT": "If you change the company name, then please also remember to update all other company contacts. Removing the company name will mean that this contact is no longer allocated to the company.",
  "MESSAGE_SUBSEQUENT_ENQUIRY_TAKE_OVER": "Enquiry taken over on",
  "MESSAGE_SUBSEQUENT_ENQUIRY_TAKE_OVER_2": "by",
  "ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS": "Further actions",
  "USER_RIGHTS_DETAILS_MANDANT": "Business unit",
  "USER_MANAGEMENT_CREATE_USER_NOTIFCATION_HEADLINE": "Your enquiry has been sent successfully.",
  "REQUEST_DETAIL_USER_INACTIVE": "User inactive",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_DENIED": "Compendium access denied",
  "REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_REQUESTED_DENIED": "Compendium access requested and denied",
  "REQUEST_OVERVIEW_FILTER_UNREAD_REQUESTS": "Unread",
  "UNSUPPORTED_FILE_TYPES": "Document type is not supported",
  "THE_FOLLOWING_FILES_ARE_UNSUPPORTED": "The following documents cannot be uploaded because the document type is not supported:",
  "REQUEST_CREATE_CONTACT_TYPE": "Contact type",
  "REQUEST_EDIT_CONTACT_TITLE": "Edit contact",
  "REQUEST_CREATE_CONTACT_HEADLINE_AREA_CODE": "Dialling code",
  "REQUEST_CREATE_CONTACT_ACCORDION_MORE_DETAILS": "More details",
  "REQUEST_DETAIL_HEADER_ADD_TAG": "Add tag",
  "REQUEST_DETAIL_HEADLINE_HISTORY": "History",
  "REQUEST_DETAIL_FILES_DOWNLOAD_ALL": "Download all documents",
  "REQUEST_DETAIL_HEADER_MENU_OFFER": "Offers",
  "REQUEST_DETAIL_HEADER_MENU_REMOVE_OFFER_MANUALLY": "Remove offer",
  "REQUEST_DETAIL_HEADER_MENU_OFFERNUMBER_HELPER_TEXT": "Enter a number. An 'A' will be added.",
  "REQUEST_DETAIL_HEADER_MENU_AMOUNT_HELPER_TEXT": "Enter a value.",
  "REQUEST_DETAIL_HEADER_MENU_CURRENCY_HELPER_TEXT": "Select a currency.",
  "REQUEST_DETAIL_LINK_ALL_ENQUIRIES": "All enquiries",
  "ADMINISTRATION_EDIT": "edit",
  "ADMINISTRATION_DELETE": "delete",
  "ADMINISTRATION_BUTTON_CONFIRM": "Confirm",
  "ADMINISTRATION_BUTTON_CANCEL": "Cancel",
  "REQUEST_DETAIL_HEADER_MENU_ORDERNUMBER_HELPER_TEXT": "Enter a number.",
  "REQUEST_DETAIL_HEADER_MENU_DELETE_OFFER": "Delete offer",
  "REQUEST_DETAIL_HEADER_MENU_DELETE_ORDER": "Delete order",
  "REQUEST_DETAIL_ADDITIONAL_ACTIONS": "More actions",
  "REQUEST_DETAIL_APPOINTMENT_HEADLINE_CONTACT_INFORMATIONS": "Contact information",
  "REQUEST_DETAIL_APPOINTMENT_HEADLINE_APPOINTMENT_DETAILS": "Appointment details",
  "REQUEST_DETAIL_APPOINTMENT_TIME": "Time*",
  "REQUEST_DETAIL_APPOINTMENT_HOUR": "Hour",
  "REQUEST_DETAIL_APPOINTMENT_MINUTE": "Minute",
  "REQUEST_DETAIL_CONNECT_BUTTON": "Create and link a new contact",
  "REQUEST_CREATE_CONTACT_FIRST_NAME_ERROR_TEXT": "Please enter a first name.",
  "REQUEST_CREATE_CONTACT_LAST_NAME_ERROR_TEXT": "Please enter a last name.",
  "REQUEST_CREATE_CONTACT_PHONE_NUMBER_ERROR_TEXT": "Please enter a phone number including the dialling code.",
  "REQUEST_CREATE_MESSAGE_UNSAVED_TITLE": "Changes not saved",
  "REQUEST_CREATE_MESSAGE_UNSAVED_DESCRIPTION": "If you leave this page your changes will be lost.",
  "REQUEST_CREATE_MESSAGE_UNSAVED_BUTTON_DISCARD": "Discard",
  "REQUEST_CREATE_MESSAGE_UNSAVED_BUTTON_SAVE": "Save",
  "PRINT_DOCUMENT_HEADLINE_HISTORY": "History",
  "PRINT_DOCUMENT_TABLE_HEADER_DATE": "Date",
  "PRINT_DOCUMENT_TABLE_HEADER_HISTORY_ENTRIES": "Entry",
  "PRINT_DOCUMENT_FOOTER_PRINTDATE": "Printed on",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_DESCRIPTION": "There are no offers or orders linked to this enquiry ID or added manually. You can link offers and orders to the enquiry ID in Composer or add an offer or order manually below.",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_LINK": "<a href=\"https://support.finstral.cloud/en/handbook-finstral-contacts/actions-processing-enquiries/processing-enquiries\" target=\"_blank\">This is how it works</a>",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_HEADLINE": "No offers available",
  "UPDATE_BANNER_POINT_NINE": "-",
  "ADMINISTRATION_DUPLICATES_TABLE_LAST_NAME": "Surname",
  "ADMINISTRATION_DUPLICATES_TABLE_EMAIL": "E-mail",
  "ADMINISTRATION_DUPLICATES_TABLE_RESPONSIBLE": "Processor",
  "ADMINISTRATION_DUPLICATES_TABLE_TEXT": "Enquiry text",
  "ADMINISTRATION_DUPLICATES_TABLE_ORIGIN": "Origin",
  "ADMINISTRATION_DUPLICATES_TABLE_COUNTRY": "Country",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_DESCRIPTION": "You currently have no offers. Add your first offer.",
  "REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_HEADLINE": "No orders available",
  "REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_DESCRIPTION": "You currently have no orders. Add your first order.",
  "USER_PROFILE_ADMINISTRATION": "Administration",
  "ADMINISTRATION_TAB_OU": "Organisational units",
  "ADMINISTRATION_OU_OVERVIEW": "Overview organisational units business unit",
  "ADMINISTRATION_OU_CREATE": "Create new organisational unit",
  "ADMINISTRATION_OU_DESCRIPTION": "Name of organisational unit*",
  "ADMINISTRATION_OU_SUPERIOR_OU": "Description of superior organisational unit",
  "ADMINISTRATION_OU_POSSIBLE_ENQUIRY_TYPES": "Responsible for enquiry types",
  "ADMINISTRATION_OU_MANDANT": "Business unit",
  "ACTION_ORDER_PLACED_INFO_TEXT_DESCRIPTION": "No order has been linked or added to this enquiry yet. Please add an order.",
  "REQUEST_DETAIL_HEADER_MENU_OFFERS_INFO_TEXT_HEADLINE": "Next step: Arrange offer handover",
  "REQUEST_DETAIL_HEADER_MENU_OFFERS_INFO_TEXT_DESCRIPTION": "Go back to the enquiry details and select ‘Arrange handover meeting’ or use <a href=\"#OFFER_SUBMIT\">this link</a> to continue directly.",
  "REQUEST_CREATE_TITLE": "Enquiry",
  "REQUEST_CREATE_HEADLINE_TAG": "Tags",
  "REQUEST_DETAIL_FILES_DELETE_ALL": "Delete all documents",
  "REQUEST_DETAIL_HEADER_MENU_REMOVE_ORDER_MANUALLY": "Remove order",
  "REQUEST_CREATE_CONTACT_SALUTATIN_ERROR_TEXT": "Please select a title.",
  "REQUEST_CREATE_CONTACT_EMAIL_ERROR_TEXT": "Please enter an email address.",
  "ADMINISTRATION_OU_SHARED_READING_RIGHT": "Shared reading rights",
  "ADMINISTRATION_OU_BUTTON_CONFIRM_CREATION": "Create organisational unit",
  "ADMINISTRATION_OU_MESSAGE_DELETION": "Are you sure you want to delete this organisational unit?",
  "ADMINISTRATION_TAB_AREA": "areas",
  "ADMINISTRATION_AREA_OVERVIEW": "Overview business unit area",
  "ADMINISTRATION_AREA_MANDANT": "Business unit areas",
  "ADMINISTRATION_OU_SHARED_READING_RIGHT_DESCRIPTION": "(the members of this organisational unit may see each other’s enquiries as soon as the areas match)",
  "REQUEST_DETAIL_HEADER_MENU_ORDERS_INFO_TEXT_DESCRIPTION": "Go back to the enquiry details and select ‘Place order’ or use <a href=\"#ORDER_PLACED\">this link</a> to continue directly.",
  "REQUEST_DETAIL_HEADER_MENU_ORFFERS_ORDERS_INPUT_ERROR_TEXT": "The number must be between 6 and 10 characters.",
  "REQUEST_OVERVIEW_ACTION_ACCEPT_ENQUIRY": "Accept",
  "REQUEST_OVERVIEW_ACTION_DECLINE_ENQUIRY": "Decline",
  "REQUEST_DETAIL_HEADER_MENU_ORDERS_INFO_TEXT_HEADLINE": "Next step: Place order",
  "PRINT_DOCUMENT_HEADLINE_ARTICLE": "Item",
  "PRINT_DOCUMENT_TABLE_HEADER_NUMBER": "Number",
  "PRINT_DOCUMENT_TABLE_HEADER_DESCRIPTION": "Description",
  "REQUEST_CREATE_SAME_CONSTUCTION_ADDRESS": "Same address as contact address",
  "REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_HEADLINE": "No entries available",
  "REQUEST_CREATE_CONTACT_ADDRESS_ERROR_TEXT": "Please enter an address.",
  "REQUEST_CREATE_CONTACT_ZIP_CODE_ERROR_TEXT": "Please enter a postcode.",
  "REQUEST_CREATE_CONTACT_LOCALITY_ERROR_TEXT": "Please enter a city.",
  "REQUEST_CREATE_CONTACT_COUNTRY_ERROR_TEXT": "Please select a country.",
  "GENERAL_TEXT_OWNER_ENQUIRY": "Enquiry owner",
  "FORM_INVALID_FIELDS": "Please check and update the invalid data.",
  "ADMINISTRATION_AREA_CREATE": "Create new area",
  "ADMINISTRATION_AREA_DESCRIPTION": "Description of area*",
  "ADMINISTRATION_AREA_NUMBER": "No. area*",
  "ADMINISTRATION_AREA_RESPONSIBLE_USER": "Assigned users",
  "ADMINISTRATION_AREA_BUTTON_CONFIRM_CREATION": "Create area",
  "ADMINISTRATION_AREA_MESSAGE_DELETION": "Are you sure you want to delete this area?",
  "ADMINISTRATION_TAB_DUPLICATES": "Duplicates",
  "ADMINISTRATION_DUPLICATES_OVERVIEW": "Overview duplicates",
  "ADMINISTRATION_DUPLICATES_TABLE_TYPE": "Type",
  "ADMINISTRATION_DUPLICATES_TABLE_NUMBER": "Enquiry no.",
  "ADMINISTRATION_DUPLICATES_TABLE_FIRST_NAME": "First Name",
  "ADMINISTRATION_DUPLICATES_TABLE_DATE": "Date",
  "ADMINISTRATION_DUPLICATES_TABLE_CREATOR": "Recorder",
  "REQUEST_DETAIL_HEADER_ENQUIRY_DETAILS": "Details of the enquiry",
  "ALT_TEXT_REQUEST_DETAIL_COPY_ID": "Copy",
  "DEADLINE_ONGOING": "Ongoing",
  "USER_PROFILE_USER_RIGHTS": "User rights",
  "USER_RIGHTS_LINK_CREATE_USER": "Create new user?",
  "USER_RIGHTS_DETAILS_ID": "ID",
  "USER_RIGHTS_DETAILS_LOGIN": "Login",
  "USER_RIGHTS_DETAILS_GENDER": "Gender",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_CLOSE_REQUESTS": "Notification for completed offer enquiries after takeover by another responsible person",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED": "Externally assigned enquiries",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED_RECIEVE_COPY": "Copy received",
  "USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED_DONT_RECIEVE_COPY": "Copy not received",
  "USER_RIGHTS_DETAILS_HEADLINE": "Access and editing rights",
  "USER_RIGHTS_DETAILS_OU": "Contacts organisational unit*",
  "USER_RIGHTS_DETAILS_ADDITIONAL_OU": "Additional Contacts organisational unit",
  "USER_RIGHTS_DETAILS_AREA": "Contacts areas*",
  "USER_RIGHTS_DETAILS_NOTIFICATIONS": "Contacts notifications",
  "USER_RIGHTS_DETAILS_ROLES": "Contacts role/s*",
  "USER_RIGHTS_DETAILS_SAVE": "Save user",
  "USER_RIGHTS_DETAILS_GENERAL_HEADLINE": "General data",
  "ADMINISTRATION_OU_EDIT": "Edit organisational units",
  "ADMINISTRATION_AREA_DELETE": "Delete area",
  "ADMINISTRATION_AREA_EDIT": "Edit areas",
  "REQUEST_DETAIL_HEADER_TAGS_ACTION_CLEAR_TAGS": "Clear all tags",
  "REQUEST_DETAIL_HEADER_ADD_TAG_INFOTEXT_SHARED_ENQUIRY": "Shared enquiry. To change this, click pen and <u>open the header data</u> to turn off sharing.",
  "REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_HEADLINE": "Collaboration with Finstral on this enquiry",
  "REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_LABEL": "Allow Finstral team members to view and write notes",
  "REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_DESCRIPTION": "Selected team members from Finstral will be able to see this enquiry and write notes.",
  "UPDATE_BANNER_POINT_ONE": "New feature for even better collaboration, design optimizations and more!",
  "REQUEST_OVERVIEW_FILTER_PREMIUM_PARTNER": "Premium Project Partner",
  "REQUEST_DETAIL_EDIT_HEADER_PROVINCE_PLACEHOLDER": "Select province",
  "REQUEST_DETAIL_EDIT_HEADER_COUNTRY_PLACEHOLDER": "Select country",
  "REQUEST_DETAIL_EDIT_HEADER_ARTICLE_SAMPLE_PLACEHOLDER": "Select sample",
  "REQUEST_DETAIL_EDIT_HEADER_ARTICLE_TENDER_PLACEHOLDER": "Select tender specifications",
  "REQUEST_DETAIL_EDIT_HEADER_ARTICLE_BROSCHURE_PLACEHOLDER": "Select brochure",
  "REQUEST_DETAIL_EDIT_HEADER_ARTICLE_CAD_PLACEHOLDER": "Select CAD data",
  "REQUEST_DETAIL_HEADER_TAGS_LABEL": "Tags",
  "REQUEST_DETAIL_HEADER_TAGS_ACTION_ADD_TAG": "Manage tags",
  "REQUEST_DETAIL_OVERLAY_TAGS_LABEL": "Tag (type or select)",
  "REQUEST_DETAIL_HISTORY_TAB_RELATED_ENQUIRIES": "Related enquiries",
  "REQUEST_DETAIL_HISTORY_RELATED_ENQUIRIES_TEXT_CREATED": "Enquiry has been created.",
  "ACTION_OFFER_SUBMIT_MESSAGE_NO_OFFER": "It looks like you haven't added any offers yet. Add your first offer <a href=\"#OFFER_EDIT\">here</a>.",
  "REQUEST_DETAIL_CONTACT_HEADLINE_WEBSITE": "Website",
  "REQUEST_OVERVIEW_BULK_MARK_AS_READ": "Mark as read",
  "REQUEST_OVERLAY_ADD_ORDER_SAVE_AND_PLACE_ORDER": "Save and place order",
  "EMAIL_EXTERNAL_TEXT": "You have been assigned the enquiry <b>{0}</b> of {1}. Please contact the prospective customer to arrange a consultation meeting and a handover meeting for the offer.",
  "UPDATE_BANNER_POINT_FOUR": "-",
  "REQUEST_DETAIL_HEADER_TAGS_SAVE": "Save tags",
  "EMAIL_TEMPLATE_CAD_1": "As an architect or planner, you have the option of registering in our planner portal and subsequently viewing CAD data, among other things. \nHere is the link for registration: https://www.finstral.com/en/registration/compendium/403-0.html.",
  "ALT_TEXT_REQUEST_DETAIL_COPY_SUCCESS": "Copied",
  "ACTION_GENERAL_HEADLINE_PERIOD_TWO_WEEKS": "In two weeks",
  "EMAIL_TEMPLATE_CLAIM_1": "Wir haben Ihre Anfrage erhalten. Um sie zu bearbeiten, senden Sie uns bitte Ihre Kontaktdaten und Ihre Rechnung, die wir benötigen, um Ihre Bestellung zurückzuverfolgen.",
  "GENERAL_TEXT_ORDER_AMOUNT_OWN": "Kundennr. (eigene)",
  "EMAIL_TEMPLATE_CAD_3": "Mocht u vragen hebben, aarzel dan niet om contact met ons op te nemen.",
  "EMAIL_TEMPLATE_SAMPLE_2": "Een Finstral-partner bij u in de buurt vindt u hier:",
  "GENERAL_TEXT_ORDER_AMOUNT_OWN\"": "Kundennr. (eigene)",
  "EMAIL_TEMPLATE_SAMPLE_3": "Immer in Ihrer Nähe."
}
